import {Icon} from "components"
import {Draggable, Droppable} from "react-beautiful-dnd"
import {ClockHoursTranscriptSubmodule} from "types/clock-hours-transcript"
import {CourseSubmoduleList} from "./CourseSubmoduleList"
import styles from "./TranscriptCourseList.module.css"

export type TranscriptCourse = {
    courseId: number
    sectionCourseId: string | number
    position?: number | null
    courseCode?: string
    courseName?: string
    credits?: number
}

type TranscriptCourseListProps = {
    sectionId: string | number
    courses: TranscriptCourse[]
    showSubmodules: boolean
    submodulesByCourseId: Record<number, ClockHoursTranscriptSubmodule[]>
    onDeleteCourse: (courseId: number, sectionId: string | number) => void
}

export const TranscriptCourseList = ({
    sectionId,
    courses,
    showSubmodules,
    submodulesByCourseId,
    onDeleteCourse
}: TranscriptCourseListProps) => {
    return (
        <div className={styles.courseList}>
            <div className={styles.headerRow}>
                <span>Code</span>
                <span>Course Name</span>
                <span>Clock</span>
                <span />
            </div>
            <Droppable droppableId={`courses:${sectionId}`} type="course">
                {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                        {courses.map((course, index) => (
                            <Draggable
                                key={course.sectionCourseId}
                                draggableId={`course-${course.sectionCourseId}`}
                                index={index}>
                                {(dragProvided, snapshot) => (
                                    <div
                                        ref={dragProvided.innerRef}
                                        {...dragProvided.draggableProps}
                                        className={`${styles.courseItem}${
                                            snapshot.isDragging ? ` ${styles.courseDragging}` : ""
                                        }`}
                                        style={dragProvided.draggableProps.style}>
                                        <div className={styles.courseRow} {...dragProvided.dragHandleProps}>
                                            <span>{course.courseCode}</span>
                                            <span>{course.courseName}</span>
                                            <span>{course.credits}</span>
                                            <div
                                                className={styles.trashButton}
                                                onMouseDown={(event) => event.stopPropagation()}
                                                onClick={() => onDeleteCourse(course.courseId, sectionId)}>
                                                <Icon icon="TRASH_LINE" />
                                            </div>
                                        </div>
                                        {showSubmodules ? (
                                            <CourseSubmoduleList
                                                droppableId={`submodules:${sectionId}:${course.courseId}`}
                                                submodules={submodulesByCourseId[course.courseId] ?? []}
                                            />
                                        ) : null}
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </div>
    )
}
